import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import r from "../../PopupTemplate.js";
import "../../renderers/ClassBreaksRenderer.js";
import "../../renderers/DictionaryRenderer.js";
import "../../renderers/DotDensityRenderer.js";
import "../../renderers/HeatmapRenderer.js";
import "../../renderers/Renderer.js";
import "../../renderers/SimpleRenderer.js";
import "../../renderers/UniqueValueRenderer.js";
import "../../renderers/support/jsonUtils.js";
import { rendererTypes as i, webSceneRendererTypes as t } from "../../renderers/support/types.js";
import o from "../../request.js";
import { isSymbol3D as s } from "../../symbols.js";
import l from "../../core/Collection.js";
import a from "../../core/Error.js";
import { HandleOwnerMixin as n } from "../../core/HandleOwner.js";
import { IdentifiableMixin as p } from "../../core/Identifiable.js";
import { clone as y } from "../../core/lang.js";
import d from "../../core/Loadable.js";
import u from "../../core/Logger.js";
import { isSome as c } from "../../core/maybe.js";
import { MultiOriginJSONMixin as f } from "../../core/MultiOriginJSONSupport.js";
import { objectToQuery as m } from "../../core/urlUtils.js";
import { property as h } from "../../core/accessorSupport/decorators/property.js";
import { getProperties as b } from "../../core/accessorSupport/utils.js";
import { cast as g } from "../../core/accessorSupport/decorators/cast.js";
import { reader as I } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as v } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as S } from "../../core/accessorSupport/decorators/writer.js";
import { ensureInteger as w, ensureType as j, Integer as D, ensureClass as L } from "../../core/accessorSupport/ensureType.js";
import { nameToId as O } from "../../core/accessorSupport/PropertyOrigin.js";
import x from "./FeatureType.js";
import P from "./Field.js";
import F from "./FieldsIndex.js";
import _ from "./LabelClass.js";
import E from "./LayerFloorInfo.js";
import { DataLayerSource as N } from "./source/DataLayerSource.js";
import { MapLayerSource as M } from "./source/MapLayerSource.js";
import T from "../../rest/support/Query.js";
import { createPopupTemplate as V } from "../../support/popupUtils.js";
import { combineFloorsDefinitionExpression as k } from "../../views/support/floorFilterUtils.js";
import A from "../../geometry/Extent.js";

var _C;

function U(e) {
  return e && "esriSMS" === e.type;
}

function q(e, r, i) {
  var t;
  var o = this.originIdOf(r) >= O(i.origin);
  return {
    ignoreOrigin: !0,
    allowNull: o,
    enabled: !!i && "map-image" === (null == (t = i.layer) ? void 0 : t.type) && (i.writeSublayerStructure || o)
  };
}

function $(e, r, i) {
  var t;
  return {
    enabled: !!i && "tile" === (null == (t = i.layer) ? void 0 : t.type) && this._isOverridden(r)
  };
}

function J(e, r, i) {
  return {
    ignoreOrigin: !0,
    enabled: i && i.writeSublayerStructure || !1
  };
}

function R(e, r, i) {
  return {
    ignoreOrigin: !0,
    enabled: !!i && (i.writeSublayerStructure || this.originIdOf(r) >= O(i.origin))
  };
}

var B = u.getLogger("esri.layers.support.Sublayer");
var Q = 0;
var G = new Set();
G.add("layer"), G.add("parent"), G.add("loaded"), G.add("loadStatus"), G.add("loadError"), G.add("loadWarnings");

var H = _C = /*#__PURE__*/function (_n) {
  _inherits(C, _n);

  var _super = _createSuper(C);

  function C(e) {
    var _this;

    _classCallCheck(this, C);

    _this = _super.call(this, e), _this.capabilities = void 0, _this.fields = null, _this.fullExtent = null, _this.globalIdField = null, _this.legendEnabled = !0, _this.objectIdField = null, _this.popupEnabled = !0, _this.popupTemplate = null, _this.sourceJSON = null, _this.title = null, _this.typeIdField = null, _this.types = null;
    return _this;
  }

  _createClass(C, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (this.addResolvingPromise(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var r, i, t, _r;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!_this2.layer && !_this2.url)) {
                            _context.next = 2;
                            break;
                          }

                          throw new a("sublayer:missing-layer", "Sublayer can't be loaded without being part of a layer", {
                            sublayer: _this2
                          });

                        case 2:
                          i = null;

                          if (!(!_this2.layer || _this2.originIdOf("url") > 2 || "data-layer" === (null == (r = _this2.source) ? void 0 : r.type))) {
                            _context.next = 9;
                            break;
                          }

                          _context.next = 6;
                          return o(_this2.url, _objectSpread({
                            responseType: "json",
                            query: {
                              f: "json"
                            }
                          }, e));

                        case 6:
                          i = _context.sent.data;
                          _context.next = 14;
                          break;

                        case 9:
                          _r = _this2.id;
                          "map-layer" === (null == (t = _this2.source) ? void 0 : t.type) && (_r = _this2.source.mapLayerId);
                          _context.next = 13;
                          return _this2.layer.fetchSublayerInfo(_r, e);

                        case 13:
                          i = _context.sent;

                        case 14:
                          i && (_this2.sourceJSON = i, _this2.read({
                            layerDefinition: i
                          }, {
                            origin: "service"
                          }));

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))()), this));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load(_x) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "readCapabilities",
    value: function readCapabilities(e, r) {
      var i = (e = (r = r.layerDefinition || r).capabilities || e) ? e.toLowerCase().split(",").map(function (e) {
        return e.trim();
      }) : [];
      return {
        exportMap: {
          supportsModification: !!r.canModifyLayer
        },
        operations: {
          supportsQuery: -1 !== i.indexOf("query")
        }
      };
    }
  }, {
    key: "definitionExpression",
    set: function set(e) {
      this._setAndNotifyLayer("definitionExpression", e);
    }
  }, {
    key: "fieldsIndex",
    get: function get() {
      return new F(this.fields || []);
    }
  }, {
    key: "floorInfo",
    set: function set(e) {
      this._setAndNotifyLayer("floorInfo", e);
    }
  }, {
    key: "readGlobalIdFieldFromService",
    value: function readGlobalIdFieldFromService(e, r) {
      if ((r = r.layerDefinition || r).globalIdField) return r.globalIdField;

      if (r.fields) {
        var _iterator = _createForOfIteratorHelper(r.fields),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _i = _step.value;
            if ("esriFieldTypeGlobalID" === _i.type) return _i.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "id",
    get: function get() {
      var e = this._get("id");

      return null == e ? Q++ : e;
    },
    set: function set(e) {
      this._get("id") !== e && (!1 !== this.get("layer.capabilities.exportMap.supportsDynamicLayers") ? this._set("id", e) : this._logLockedError("id", "capability not available 'layer.capabilities.exportMap.supportsDynamicLayers'"));
    }
  }, {
    key: "labelingInfo",
    set: function set(e) {
      this._setAndNotifyLayer("labelingInfo", e);
    }
  }, {
    key: "writeLabelingInfo",
    value: function writeLabelingInfo(e, r, i, t) {
      e && e.length && (r.layerDefinition = {
        drawingInfo: {
          labelingInfo: e.map(function (e) {
            return e.write({}, t);
          })
        }
      });
    }
  }, {
    key: "labelsVisible",
    set: function set(e) {
      this._setAndNotifyLayer("labelsVisible", e);
    }
  }, {
    key: "layer",
    set: function set(e) {
      this._set("layer", e), this.sublayers && this.sublayers.forEach(function (r) {
        return r.layer = e;
      });
    }
  }, {
    key: "listMode",
    set: function set(e) {
      this._set("listMode", e);
    }
  }, {
    key: "minScale",
    set: function set(e) {
      this._setAndNotifyLayer("minScale", e);
    }
  }, {
    key: "readMinScale",
    value: function readMinScale(e, r) {
      return r.minScale || r.layerDefinition && r.layerDefinition.minScale || 0;
    }
  }, {
    key: "maxScale",
    set: function set(e) {
      this._setAndNotifyLayer("maxScale", e);
    }
  }, {
    key: "readMaxScale",
    value: function readMaxScale(e, r) {
      return r.maxScale || r.layerDefinition && r.layerDefinition.maxScale || 0;
    }
  }, {
    key: "readObjectIdFieldFromService",
    value: function readObjectIdFieldFromService(e, r) {
      if ((r = r.layerDefinition || r).objectIdField) return r.objectIdField;

      if (r.fields) {
        var _iterator2 = _createForOfIteratorHelper(r.fields),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _i2 = _step2.value;
            if ("esriFieldTypeOID" === _i2.type) return _i2.name;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "opacity",
    set: function set(e) {
      this._setAndNotifyLayer("opacity", e);
    }
  }, {
    key: "readOpacity",
    value: function readOpacity(e, r) {
      var i = r.layerDefinition;
      return 1 - .01 * (null != i.transparency ? i.transparency : i.drawingInfo.transparency);
    }
  }, {
    key: "writeOpacity",
    value: function writeOpacity(e, r, i, t) {
      r.layerDefinition = {
        drawingInfo: {
          transparency: 100 - 100 * e
        }
      };
    }
  }, {
    key: "writeParent",
    value: function writeParent(e, r) {
      this.parent && this.parent !== this.layer ? r.parentLayerId = w(this.parent.id) : r.parentLayerId = -1;
    }
  }, {
    key: "defaultPopupTemplate",
    get: function get() {
      return this.createPopupTemplate();
    }
  }, {
    key: "renderer",
    set: function set(e) {
      if (e) {
        var _iterator3 = _createForOfIteratorHelper(e.getSymbols()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var r = _step3.value;

            if (s(r)) {
              B.warn("Sublayer renderer should use 2D symbols");
              break;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      this._setAndNotifyLayer("renderer", e);
    }
  }, {
    key: "source",
    get: function get() {
      return this._get("source") || new M({
        mapLayerId: this.id
      });
    },
    set: function set(e) {
      this._setAndNotifyLayer("source", e);
    }
  }, {
    key: "sublayers",
    set: function set(e) {
      this._handleSublayersChange(e, this._get("sublayers")), this._set("sublayers", e);
    }
  }, {
    key: "castSublayers",
    value: function castSublayers(e) {
      return j(l.ofType(_C), e);
    }
  }, {
    key: "writeSublayers",
    value: function writeSublayers(e, r, i) {
      this.get("sublayers.length") && (r[i] = this.sublayers.map(function (e) {
        return e.id;
      }).toArray().reverse());
    }
  }, {
    key: "readTypeIdField",
    value: function readTypeIdField(e, r) {
      var i = (r = r.layerDefinition || r).typeIdField;

      if (i && r.fields) {
        i = i.toLowerCase();

        var _e = r.fields.find(function (e) {
          return e.name.toLowerCase() === i;
        });

        _e && (i = _e.name);
      }

      return null;
    }
  }, {
    key: "url",
    get: function get() {
      var e, r;
      var i = null != (e = null == (r = this.layer) ? void 0 : r.parsedUrl) ? e : this._lastParsedUrl,
          t = this.source;
      if (!i) return null;
      if (this._lastParsedUrl = i, "map-layer" === (null == t ? void 0 : t.type)) return "".concat(i.path, "/").concat(t.mapLayerId);
      var o = {
        layer: JSON.stringify({
          source: this.source
        })
      };
      return "".concat(i.path, "/dynamicLayer?").concat(m(o));
    },
    set: function set(e) {
      e ? this._override("url", e) : this._clearOverride("url");
    }
  }, {
    key: "visible",
    set: function set(e) {
      this._setAndNotifyLayer("visible", e);
    }
  }, {
    key: "writeVisible",
    value: function writeVisible(e, r, i, t) {
      r[i] = this.getAtOrigin("defaultVisibility", "service") || e;
    }
  }, {
    key: "clone",
    value: function clone() {
      var _b = b(this),
          e = _b.store,
          r = new _C();

      return b(r).store = e.clone(G), this.commitProperty("url"), r._lastParsedUrl = this._lastParsedUrl, r;
    }
  }, {
    key: "createPopupTemplate",
    value: function createPopupTemplate(e) {
      return V(this, e);
    }
  }, {
    key: "createQuery",
    value: function createQuery() {
      return new T({
        returnGeometry: !0,
        where: this.definitionExpression || "1=1"
      });
    }
  }, {
    key: "createFeatureLayer",
    value: function () {
      var _createFeatureLayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var e, r, i, t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.hasOwnProperty("sublayers")) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", null);

              case 2:
                i = null == (e = this.layer) ? void 0 : e.parsedUrl;
                0;
                _context3.next = 6;
                return import("../FeatureLayer.js");

              case 6:
                _context3.t0 = _context3.sent.default;
                _context3.t1 = {
                  url: i.path
                };
                t = new _context3.t0(_context3.t1);
                return _context3.abrupt("return", (i && this.source && ("map-layer" === this.source.type ? t.layerId = this.source.mapLayerId : t.dynamicDataSource = this.source), null != this.layer.refreshInterval && (t.refreshInterval = this.layer.refreshInterval), this.definitionExpression && (t.definitionExpression = this.definitionExpression), this.floorInfo && (t.floorInfo = y(this.floorInfo)), this.originIdOf("labelingInfo") > 2 && (t.labelingInfo = y(this.labelingInfo)), this.originIdOf("labelsVisible") > 0 && (t.labelsVisible = this.labelsVisible), this.originIdOf("legendEnabled") > 0 && (t.legendEnabled = this.legendEnabled), this.originIdOf("visible") > 0 && (t.visible = this.visible), this.originIdOf("minScale") > 0 && (t.minScale = this.minScale), this.originIdOf("maxScale") > 0 && (t.maxScale = this.maxScale), this.originIdOf("opacity") > 0 && (t.opacity = this.opacity), this.originIdOf("popupTemplate") > 0 && (t.popupTemplate = y(this.popupTemplate)), this.originIdOf("renderer") > 2 && (t.renderer = y(this.renderer)), "data-layer" === (null == (r = this.source) ? void 0 : r.type) && (t.dynamicDataSource = this.source.clone()), this.originIdOf("title") > 0 && (t.title = this.title), "map-image" === this.layer.type && this.layer.originIdOf("customParameters") > 0 && (t.customParameters = this.layer.customParameters), "tile" === this.layer.type && this.layer.originIdOf("customParameters") > 0 && (t.customParameters = this.layer.customParameters), t));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createFeatureLayer() {
        return _createFeatureLayer.apply(this, arguments);
      }

      return createFeatureLayer;
    }()
  }, {
    key: "getField",
    value: function getField(e) {
      return this.fieldsIndex.get(e);
    }
  }, {
    key: "getFeatureType",
    value: function getFeatureType(e) {
      var r = this.typeIdField,
          i = this.types;
      if (!r || !e) return null;
      var t = e.attributes ? e.attributes[r] : void 0;
      if (null == t) return null;
      var o = null;
      return i.some(function (e) {
        var r = e.id;
        return null != r && (r.toString() === t.toString() && (o = e), !!o);
      }), o;
    }
  }, {
    key: "getFieldDomain",
    value: function getFieldDomain(e, r) {
      var i = r && r.feature,
          t = this.getFeatureType(i);

      if (t) {
        var _r2 = t.domains && t.domains[e];

        if (_r2 && "inherited" !== _r2.type) return _r2;
      }

      return this._getLayerDomain(e);
    }
  }, {
    key: "queryFeatures",
    value: function () {
      var _queryFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var e,
            r,
            i,
            t,
            o,
            s,
            _yield$Promise$all,
            _yield$Promise$all2,
            l,
            n,
            p,
            y,
            _iterator4,
            _step4,
            _a,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                e = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : this.createQuery();
                r = _args4.length > 1 ? _args4[1] : undefined;
                _context4.next = 4;
                return this.load();

              case 4:
                if (this.get("capabilities.operations.supportsQuery")) {
                  _context4.next = 6;
                  break;
                }

                throw new a("Sublayer.queryFeatures", "this layer doesn't support queries.");

              case 6:
                _context4.next = 8;
                return Promise.all([import("../../rest/query/operations/query.js"), import("../../rest/support/FeatureSet.js")]);

              case 8:
                _yield$Promise$all = _context4.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                l = _yield$Promise$all2[0].executeQuery;
                n = _yield$Promise$all2[1].default;
                _context4.next = 14;
                return l(this.url, T.from(e), null != (i = null == (t = this.layer) ? void 0 : t.spatialReference) ? i : null, _objectSpread(_objectSpread({}, r), {}, {
                  query: _objectSpread(_objectSpread({}, null == (o = this.layer) ? void 0 : o.customParameters), {}, {
                    token: null == (s = this.layer) ? void 0 : s.apiKey
                  })
                }));

              case 14:
                p = _context4.sent;
                y = n.fromJSON(p.data);

                if (null != y && y.features) {
                  _iterator4 = _createForOfIteratorHelper(y.features);

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      _a = _step4.value;
                      _a.sourceLayer = this;
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                }

                return _context4.abrupt("return", y);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function queryFeatures() {
        return _queryFeatures.apply(this, arguments);
      }

      return queryFeatures;
    }()
  }, {
    key: "toExportImageJSON",
    value: function toExportImageJSON(e) {
      var _this3 = this;

      var r;
      var i = {
        id: this.id,
        source: (null == (r = this.source) ? void 0 : r.toJSON()) || {
          mapLayerId: this.id,
          type: "mapLayer"
        }
      };

      if (this.definitionExpression) {
        var _r3 = c(e) ? k(e, this) : this.definitionExpression;

        i.definitionExpression = _r3;
      } else c(e) && (i.definitionExpression = e);

      var t = ["renderer", "labelingInfo", "opacity", "labelsVisible"].reduce(function (e, r) {
        return e[r] = _this3.originIdOf(r), e;
      }, {}),
          o = Object.keys(t).some(function (e) {
        return t[e] > 2;
      });

      if (o) {
        var _e2 = i.drawingInfo = {};

        t.renderer > 2 && (_e2.renderer = this.renderer ? this.renderer.toJSON() : null), t.labelsVisible > 2 && (_e2.showLabels = this.labelsVisible), this.labelsVisible && t.labelingInfo > 2 && (_e2.labelingInfo = this.labelingInfo ? this.labelingInfo.map(function (e) {
          return e.write({}, {
            origin: "service",
            layer: _this3.layer
          });
        }) : null, _e2.showLabels = !0), t.opacity > 2 && (_e2.transparency = 100 - 100 * this.opacity), this._assignDefaultSymbolColors(_e2.renderer);
      }

      return i;
    }
  }, {
    key: "_assignDefaultSymbolColors",
    value: function _assignDefaultSymbolColors(e) {
      this._forEachSimpleMarkerSymbols(e, function (e) {
        e.color || "esriSMSX" !== e.style && "esriSMSCross" !== e.style || (e.outline && e.outline.color ? e.color = e.outline.color : e.color = [0, 0, 0, 0]);
      });
    }
  }, {
    key: "_forEachSimpleMarkerSymbols",
    value: function _forEachSimpleMarkerSymbols(e, r) {
      if (e) {
        var i = "uniqueValueInfos" in e ? e.uniqueValueInfos : "classBreakInfos" in e ? e.classBreakInfos : [];

        var _iterator5 = _createForOfIteratorHelper(i),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _e3 = _step5.value;
            U(_e3.symbol) && r(_e3.symbol);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        "symbol" in e && U(e.symbol) && r(e.symbol), "defaultSymbol" in e && U(e.defaultSymbol) && r(e.defaultSymbol);
      }
    }
  }, {
    key: "_setAndNotifyLayer",
    value: function _setAndNotifyLayer(e, r) {
      var i = this.layer,
          t = this._get(e);

      var o, s;

      switch (e) {
        case "definitionExpression":
        case "floorInfo":
          o = "supportsSublayerDefinitionExpression";

        case "minScale":
        case "maxScale":
        case "visible":
          o = "supportsSublayerVisibility";
          break;

        case "labelingInfo":
        case "labelsVisible":
        case "opacity":
        case "renderer":
        case "source":
          o = "supportsDynamicLayers", s = "supportsModification";
      }

      var l = b(this).getDefaultOrigin();

      if ("service" !== l) {
        if (o && !1 === this.get("layer.capabilities.exportMap.".concat(o))) return void this._logLockedError(e, "capability not available 'layer.capabilities.exportMap.".concat(o, "'"));
        if (s && !1 === this.get("capabilities.exportMap.".concat(s))) return void this._logLockedError(e, "capability not available 'capabilities.exportMap.".concat(s, "'"));
      }

      "source" !== e || "not-loaded" === this.loadStatus ? (this._set(e, r), "service" !== l && t !== r && i && i.emit && i.emit("sublayer-update", {
        propertyName: e,
        target: this
      })) : this._logLockedError(e, "'source' can't be changed after calling sublayer.load()");
    }
  }, {
    key: "_handleSublayersChange",
    value: function _handleSublayersChange(e, r) {
      var _this4 = this;

      r && (r.forEach(function (e) {
        e.parent = null, e.layer = null;
      }), this.handles.removeAll()), e && (e.forEach(function (e) {
        e.parent = _this4, e.layer = _this4.layer;
      }), this.handles.add([e.on("after-add", function (_ref2) {
        var e = _ref2.item;
        e.parent = _this4, e.layer = _this4.layer;
      }), e.on("after-remove", function (_ref3) {
        var e = _ref3.item;
        e.parent = null, e.layer = null;
      }), e.on("before-changes", function (e) {
        var r = _this4.get("layer.capabilities.exportMap.supportsSublayersChanges");

        null == r || r || (B.error(new a("sublayer:sublayers-non-modifiable", "Sublayer can't be added, moved, or removed from the layer's sublayers", {
          sublayer: _this4,
          layer: _this4.layer
        })), e.preventDefault());
      })]));
    }
  }, {
    key: "_logLockedError",
    value: function _logLockedError(e, r) {
      B.error(new a("sublayer:locked", "Property '".concat(e, "' can't be changed on Sublayer from the layer '").concat(this.layer.id, "'"), {
        reason: r,
        sublayer: this,
        layer: this.layer
      }));
    }
  }, {
    key: "_getLayerDomain",
    value: function _getLayerDomain(e) {
      var r = this.fieldsIndex.get(e);
      return r ? r.domain : null;
    }
  }]);

  return C;
}(n(f(p(d))));

H.test = {
  isMapImageLayerOverridePolicy: function isMapImageLayerOverridePolicy(e) {
    return e === J || e === q;
  },
  isTileImageLayerOverridePolicy: function isTileImageLayerOverridePolicy(e) {
    return e === $;
  }
}, e([h({
  readOnly: !0
})], H.prototype, "capabilities", void 0), e([I("service", "capabilities", ["layerDefinition.canModifyLayer", "layerDefinition.capabilities"])], H.prototype, "readCapabilities", null), e([h({
  type: String,
  value: null,
  json: {
    name: "layerDefinition.definitionExpression",
    write: {
      allowNull: !0,
      overridePolicy: q
    }
  }
})], H.prototype, "definitionExpression", null), e([h({
  type: [P],
  json: {
    origins: {
      service: {
        read: {
          source: "layerDefinition.fields"
        }
      }
    }
  }
})], H.prototype, "fields", void 0), e([h({
  readOnly: !0
})], H.prototype, "fieldsIndex", null), e([h({
  type: E,
  value: null,
  json: {
    name: "layerDefinition.floorInfo",
    read: {
      source: "layerDefinition.floorInfo"
    },
    write: {
      target: "layerDefinition.floorInfo",
      overridePolicy: q
    },
    origins: {
      "web-scene": {
        read: !1,
        write: !1
      }
    }
  }
})], H.prototype, "floorInfo", null), e([h({
  type: A,
  json: {
    read: {
      source: "layerDefinition.extent"
    }
  }
})], H.prototype, "fullExtent", void 0), e([h({
  type: String
})], H.prototype, "globalIdField", void 0), e([I("service", "globalIdField", ["layerDefinition.globalIdField", "layerDefinition.fields"])], H.prototype, "readGlobalIdFieldFromService", null), e([h({
  type: D,
  json: {
    write: {
      ignoreOrigin: !0
    }
  }
})], H.prototype, "id", null), e([h({
  value: null,
  type: [_],
  json: {
    read: {
      source: "layerDefinition.drawingInfo.labelingInfo"
    },
    write: {
      target: "layerDefinition.drawingInfo.labelingInfo",
      overridePolicy: J
    }
  }
})], H.prototype, "labelingInfo", null), e([S("labelingInfo")], H.prototype, "writeLabelingInfo", null), e([h({
  type: Boolean,
  value: !0,
  json: {
    read: {
      source: "layerDefinition.drawingInfo.showLabels"
    },
    write: {
      target: "layerDefinition.drawingInfo.showLabels",
      overridePolicy: J
    }
  }
})], H.prototype, "labelsVisible", null), e([h({
  value: null
})], H.prototype, "layer", null), e([h({
  type: Boolean,
  value: !0,
  json: {
    origins: {
      service: {
        read: {
          enabled: !1
        }
      }
    },
    read: {
      source: "showLegend"
    },
    write: {
      target: "showLegend",
      overridePolicy: R
    }
  }
})], H.prototype, "legendEnabled", void 0), e([h({
  type: ["show", "hide", "hide-children"],
  value: "show",
  json: {
    read: !1,
    write: !1,
    origins: {
      "web-scene": {
        read: !0,
        write: !0
      }
    }
  }
})], H.prototype, "listMode", null), e([h({
  type: Number,
  value: 0,
  json: {
    write: {
      overridePolicy: J
    }
  }
})], H.prototype, "minScale", null), e([I("minScale", ["minScale", "layerDefinition.minScale"])], H.prototype, "readMinScale", null), e([h({
  type: Number,
  value: 0,
  json: {
    write: {
      overridePolicy: J
    }
  }
})], H.prototype, "maxScale", null), e([I("maxScale", ["maxScale", "layerDefinition.maxScale"])], H.prototype, "readMaxScale", null), e([h({
  type: String
})], H.prototype, "objectIdField", void 0), e([I("service", "objectIdField", ["layerDefinition.objectIdField", "layerDefinition.fields"])], H.prototype, "readObjectIdFieldFromService", null), e([h({
  type: Number,
  value: 1,
  json: {
    write: {
      target: "layerDefinition.drawingInfo.transparency",
      overridePolicy: J
    }
  }
})], H.prototype, "opacity", null), e([I("opacity", ["layerDefinition.drawingInfo.transparency", "layerDefinition.transparency"])], H.prototype, "readOpacity", null), e([S("opacity")], H.prototype, "writeOpacity", null), e([h({
  json: {
    type: D,
    write: {
      target: "parentLayerId",
      writerEnsuresNonNull: !0,
      overridePolicy: J
    }
  }
})], H.prototype, "parent", void 0), e([S("parent")], H.prototype, "writeParent", null), e([h({
  type: Boolean,
  value: !0,
  json: {
    read: {
      source: "disablePopup",
      reader: function reader(e, r) {
        return !r.disablePopup;
      }
    },
    write: {
      target: "disablePopup",
      overridePolicy: R,
      writer: function writer(e, r, i) {
        r[i] = !e;
      }
    }
  }
})], H.prototype, "popupEnabled", void 0), e([h({
  type: r,
  json: {
    read: {
      source: "popupInfo"
    },
    write: {
      target: "popupInfo",
      overridePolicy: R
    }
  }
})], H.prototype, "popupTemplate", void 0), e([h({
  readOnly: !0
})], H.prototype, "defaultPopupTemplate", null), e([h({
  types: i,
  value: null,
  json: {
    name: "layerDefinition.drawingInfo.renderer",
    write: {
      overridePolicy: J
    },
    origins: {
      "web-scene": {
        types: t,
        name: "layerDefinition.drawingInfo.renderer",
        write: {
          overridePolicy: J
        }
      }
    }
  }
})], H.prototype, "renderer", null), e([h({
  types: {
    key: "type",
    base: null,
    typeMap: {
      "data-layer": N,
      "map-layer": M
    }
  },
  cast: function cast(e) {
    if (e) {
      if ("mapLayerId" in e) return L(M, e);
      if ("dataSource" in e) return L(N, e);
    }

    return e;
  },
  json: {
    name: "layerDefinition.source",
    write: {
      overridePolicy: J
    }
  }
})], H.prototype, "source", null), e([h()], H.prototype, "sourceJSON", void 0), e([h({
  value: null,
  json: {
    type: [D],
    write: {
      target: "subLayerIds",
      allowNull: !0,
      overridePolicy: J
    }
  }
})], H.prototype, "sublayers", null), e([g("sublayers")], H.prototype, "castSublayers", null), e([S("sublayers")], H.prototype, "writeSublayers", null), e([h({
  type: String,
  json: {
    name: "name",
    write: {
      overridePolicy: R
    }
  }
})], H.prototype, "title", void 0), e([h({
  type: String
})], H.prototype, "typeIdField", void 0), e([I("typeIdField", ["layerDefinition.typeIdField"])], H.prototype, "readTypeIdField", null), e([h({
  type: [x],
  json: {
    origins: {
      service: {
        read: {
          source: "layerDefinition.types"
        }
      }
    }
  }
})], H.prototype, "types", void 0), e([h({
  type: String,
  json: {
    read: {
      source: "layerUrl"
    },
    write: {
      target: "layerUrl",
      overridePolicy: $
    }
  }
})], H.prototype, "url", null), e([h({
  type: Boolean,
  value: !0,
  json: {
    read: {
      source: "defaultVisibility"
    },
    write: {
      target: "defaultVisibility",
      overridePolicy: J
    }
  }
})], H.prototype, "visible", null), e([S("visible")], H.prototype, "writeVisible", null), H = _C = e([v("esri.layers.support.Sublayer")], H);
var K = H;
export { K as default };